import { logAPI } from "./andyliticsApi";
import { inHomeVerifyErrors } from "../constants/textConstants"

const BASE_URL = window.serverData.data.inHomeBaseUrl;
const API_KEY = window.serverData.data.inHomeFunctionsKey;
const COVID_Q_BASE_URL = window.serverData.data.inHomeCovidQuestionnaireBaseUrl;
import { inHomeWhereErrors } from '../constants/textConstants';
const CLIENT_ID = "MBHWeb.IHV";

export const getPrefilledData = (mrn, token) => {
    const fullUrl = `${BASE_URL}axle/v2/prefill?mrn=${mrn}`;
    const start = new Date();
    const params = {
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        method: "GET"
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.InHome.GetAddressPrefill", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.GetAddressPrefill.Failure", start, fullUrl, err.message);
            return Promise.reject(err);
        });
}


export const getAvailableVaccines = (body, token) => {
    const fullUrl = `${BASE_URL}axle/v3/vaccines`;
    const start = new Date();
    const params = {
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        method: "POST",
        body: JSON.stringify(body)
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.InHome.GetAvailableVaccines", start, fullUrl);

            if (response.status == 204) {
                logAPI("MBHWeb.Api.InHome.GetAvailableVaccines.NoVaccinesAvailable", start, fullUrl, inHomeWhereErrors.noVax);
                throw new Error(inHomeWhereErrors.noVax);
            } else if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else if (response.status == 400) {
                logAPI("MBHWeb.Api.InHome.GetAvailableVaccines.NotInServiceArea", start, fullUrl, inHomeWhereErrors.notValidZip);               
                return response.json().then(err => {
                    if (typeof (err) === 'object' && err.error_code && err.error_code === "invalid_zip_code")
                        throw new Error(inHomeWhereErrors.notValidZip);
                    else if (typeof (err) === 'object' && err.error_code && err.error_code === "vaccines_not_available")
                        throw new Error(err.message);
                    else
                        throw err.message
                });
                
            }
            else if (response.status > 400 && response.status < 500) {
                logAPI("MBHWeb.Api.InHome.GetAvailableVaccines.NotInServiceArea", start, fullUrl, inHomeWhereErrors.notInServiceArea);
                throw new Error(inHomeWhereErrors.notInServiceArea);
            } else {
                throw new Error(inHomeWhereErrors.other);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.GetAvailableVaccines.Failure", start, fullUrl, err.message);           
            throw new Error(err.message);
        });
}


export const validateZipCode = (body, token) => {
    const fullUrl = `${BASE_URL}axle/v1/verify/zip`;
    const start = new Date();
    const params = {
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        method: "POST",
        body: JSON.stringify(body)
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.InHome.ValidateZipCode", start, fullUrl);

            if (response.status == 204) {
                logAPI("MBHWeb.Api.InHome.ValidateZipCode.NoVaccinesAvailable", start, fullUrl, inHomeWhereErrors.noVax);
                throw new Error(inHomeWhereErrors.noVax);
            } else if (response.status >= 200 && response.status < 300) {
                return Promise.resolve(response.text() || 'success');
            }
            else if (response.status == 400) {
                logAPI("MBHWeb.Api.InHome.ValidateZipCode.NotInServiceArea", start, fullUrl, inHomeWhereErrors.notValidZip);
                return response.json().then(err => {
                    if (typeof (err) === 'object' && err.error_code && err.error_code === "invalid_zip_code")
                        throw new Error(inHomeWhereErrors.notValidZip);
                    else if (typeof (err) === 'object' && err.error_code && err.error_code === "vaccines_not_available")
                        throw new Error(err.message);
                    else
                        throw err.message
                });

            }
            else if (response.status > 400 && response.status < 500) {
                logAPI("MBHWeb.Api.InHome.ValidateZipCode.NotInServiceArea", start, fullUrl, inHomeWhereErrors.notInServiceArea);
                throw new Error(inHomeWhereErrors.notInServiceArea);
            } else {
                throw new Error(inHomeWhereErrors.other);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.ValidateZipCode.Failure", start, fullUrl, err.message);
            throw new Error(err.message);
        });
}

export const getAvailableDateTimes = (body, token) => {
    const fullUrl = `${BASE_URL}axle/v1/availability`;
    const start = new Date();
    const params = {
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        method: "POST",
        body: JSON.stringify(body)
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.InHome.GetAvailableDateTimes", start, fullUrl);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.GetAvailableDateTimes.Failure", start, fullUrl, err.message);
            return Promise.reject(err);
        });
}

export const bookInhomeAppointment = (body, token) => {
    //const fullUrl = `${BASE_URL}axle/v1/visit`;
    const fullUrl = `${BASE_URL}axle/v2/visit`;
    const start = new Date();
    const params = {
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        method: "POST",
        body: JSON.stringify(body)
    };

    return fetch(fullUrl, params)
        .then(async response => {
            logAPI("MBHWeb.Api.InHome.BookInhomeAppointment", start, fullUrl);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else if (response.status == 409) {
                logAPI("MBHWeb.Api.InHome.BookInhomeAppointment.TimeAlreadyBooked", start, fullUrl);
                throw new Error(inHomeVerifyErrors.TimeAlreadyBooked);
            } else if (response.status >= 400 && response.status < 500) {
                let error = await response.json()
                throw new Error(error.message);
            } else {
                throw new Error("Unknown error");
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.BookInhomeAppointment.Failure", start, fullUrl, err.message);
            throw new Error(err.message);
        });
}

export const getCovidVaccineQuestionnaires = (body, token) => {
    const fullUrl = `${COVID_Q_BASE_URL}${body}`;
    const start = new Date();
    const params = {
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        method: "GET",
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.InHome.GetCovidVaccineQuestionnaires", start, fullUrl);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.GetCovidVaccineQuestionnaires.Failure", start, fullUrl), err.message;
            return Promise.reject(err);
        });
}

export const getVaccineQuestionnaires = (body, token) => {
    const fullUrl = `${BASE_URL}/v1/questionnaires/vaccine`;
    const start = new Date();
    const params = {
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": `bearer ${token}`,
            "x-functions-key": API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        method: "POST",
        body: JSON.stringify(body)
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.InHome.GetVaccineQuestionnaires", start, fullUrl);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.GetVaccineQuestionnaires.Failure", start, fullUrl), err.message;
            return Promise.reject(err);
        });
}

export const putVaccineQuestionnaires = (token, body) => {
    const fullUrl = `${BASE_URL}/v1/questionnaires/vaccine`;
    const start = new Date();
    const params = {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-functions-key': API_KEY,
            "x-bsw-clientid": CLIENT_ID
        },
        body: JSON.stringify(body)
    }

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.InHome.SendVaccineQuestionnaires", start, fullUrl);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.InHome.SendVaccineQuestionnaires.Failure", start, fullUrl, err.message);
            return Promise.reject(err);
        });
};